const ErrorPage = () => {
  return (
    <section className="min-h-screen flex items-center justify-center bg-white">
      <div className="w-full flex flex-col items-center justify-center text-center px-4">
        <div className="text-[8rem] font-extrabold text-gray-400 leading-none select-none">
          404
        </div>
        <h1 className="text-4xl font-semibold mt-2">Something went wrong</h1>
        <p className="text-xl max-w-2xl mt-6">
          The page or resource you're trying to access has been removed or you
          don't have sufficient permission to access.
        </p>
      </div>
    </section>
  );
};

export default ErrorPage;
